import { PowerFunnelUserStatuses } from './constants';

/**
 * Derive the funnel-facing `userSubscriptionStatus` value used across the
 * annual-Power upgrade telemetry. The three buckets the funnel cares about are:
 *
 *  - `POWER_PAST_DUE` — any Power subscriber whose subscription is past-due.
 *  - `MONTHLY`        — active monthly Power subscriber.
 *  - `FREE`           — everyone else (the upsell target).
 *
 * Past-due is checked first, and across both intervals. `isMonthlySubscriber` is
 * derived upstream (e.g. SideBar) from `isPowered || hasPastDueSubscription`, so a
 * past-due monthly subscriber arrives here with that flag set; bucketing them as
 * MONTHLY made a lapsed subscriber indistinguishable from a paying one and left
 * every past-due monthly out of the churn signal.
 */
export const deriveUserSubscriptionStatus = ({ user, isMonthlySubscriber } = {}) => {
    if (user?.hasPastDueSubscription) {
        return PowerFunnelUserStatuses.POWER_PAST_DUE;
    }
    if (isMonthlySubscriber) {
        return PowerFunnelUserStatuses.MONTHLY;
    }
    return PowerFunnelUserStatuses.FREE;
};
